import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 8px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    justify-content: space-between;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
  }
`;

export const PrevNextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleWrapper = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  ::first-letter {
    text-transform: uppercase;
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: flex-end;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
    align-items: baseline;
    gap: 16px;
  }
`;
